import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CerrixTreeItem } from "@models/tree/CerrixTreeItem";
import { CerrixTreeItemPickerComponent } from "@app/shared/organisms/cerrix-tree-item-picker/cerrix-tree-item-picker.component";

@Component({
    selector: "app-cerrix-tree-item-picker-multiple",
    imports: [CerrixTreeItemPickerComponent],
    templateUrl: "./cerrix-tree-item-picker-multiple.component.html",
})
export class CerrixTreeItemPickerMultipleComponent {
    @Input() name = "tree-item-picker";
    @Input() label: string;
    @Input() infoText = "";
    @Input() placeholder = "";
    @Input() dialogTitle: string;
    @Input() iconPrefix = "";
    @Input() defaultIcon = "";
    @Input() items: CerrixTreeItem[] = [];
    @Input() selectedValue: string[];
    @Output() valueChanged = new EventEmitter<string[]>();
}
